<template>
	<div class="course-more-page">
		<div class="container">
			<!-- Breadcrumb -->
			<div class="breadcrumb">
				<span class="breadcrumb-item" @click="goHome">首页</span>
				<span class="separator">&gt;</span>
				<span class="breadcrumb-item active">{{ title }}</span>
			</div>

			<!-- Course Grid -->
			<div class="course-grid" v-if="courseList.length > 0">
				<div class="course-card" v-for="(course, index) in courseList" :key="index" @click="goToDetail(course.courseId)">
					<div class="course-cover">
						<img :src="course.coverImg" alt="" v-if="course.coverImg">
						<span class="badge" :class="getBadgeType(course.viewType)">{{ getBadgeText(course.viewType)
							}}</span>
					</div>
					<div class="course-info">
						<h4>{{ course.title }}</h4>
						<p>{{ course.sales || 0 }}人浏览</p>
					</div>
				</div>
			</div>

			<EmptyState v-else description="暂无课程数据" />

			<!-- Pagination (Optional, simplified for now) -->
			<!-- <div class="pagination" v-if="total > pageSize">
				...
			</div> -->
		</div>
	</div>
</template>

<script>
	import ProductAPI from '@/api/product'
	import EmptyState from '@/components/EmptyState.vue'

	export default {
		name: 'CourseMore',
		components: {
			EmptyState
		},
		data() {
			return {
				title: '专区列表',
				categoryId: null,
				productGroupId: null,
				courseList: [],
				loading: false,
				queryParams: {
					pageNum: 1,
					pageSize: 20,
					viewType: null, // Add viewType to queryParams
					title: '' // Add title to queryParams
				}
			}
		},
		created() {
			this.initParams()
			this.fetchCourses()
		},
		methods: {
			initParams() {
				const {
					title,
					productGroupId,
					viewType
				} = this.$route.query

				if (title) {
					this.title = title
					// 仅展示：有 productGroupId 时（如从首页「更多」进入）不把 title 当搜索条件
					if (!productGroupId) {
						this.queryParams.title = title
					}
				}

				if (productGroupId) {
					this.productGroupId = productGroupId
				}
				if (viewType) {
					this.queryParams.viewType = parseInt(viewType)
				}
			},
			async fetchCourses() {
				// Remove strict check, allow fetching if parameters exist
				// if (!this.categoryId && !this.productGroupId) return

				this.loading = true
				try {
					const params = {
						...this.queryParams
					}
					if (this.productGroupId) {
						params.productGroupId = this.productGroupId
					}

					// Remove null/empty/undefined values to keep query clean
					Object.keys(params).forEach(key => {
						if (params[key] === null || params[key] === '' || params[key] === undefined) {
							delete params[key]
						}
					})

					const res = await ProductAPI.getCourseList(params)

					if (res && Array.isArray(res.rows)) {
						this.courseList = res.rows
					} else if (res && res.data && Array.isArray(res.data.rows)) {
						this.courseList = res.data.rows
					} else if (res && Array.isArray(res.list)) {
						this.courseList = res.list
					} else if (Array.isArray(res)) {
						this.courseList = res
					} else if (res && res.data && Array.isArray(res.data)) {
						this.courseList = res.data
					} else {
						this.courseList = []
					}
				} catch (error) {
					console.error('Failed to fetch courses:', error)
				} finally {
					this.loading = false
				}
			},
			goHome() {
				this.$router.push('/')
			},
			getBadgeType(viewType) {
				if (viewType === 2) return 'vip';
				if (viewType === 3) return 'paid';
				return 'free';
			},
			getBadgeText(viewType) {
				if (viewType === 2) return 'VIP';
				if (viewType === 3) return '付费';
				return '免费';
			},
			goToDetail(id) {
				this.$router.push({
					name: 'CourseDetail',
					params: {
						id: id
					}
				})
			}
		}
	}
</script>

<style scoped>
	.course-more-page {
		min-height: 100vh;
		background-color: #111;
		color: #fff;
		padding: 20px 0;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 20px;
	}

	/* Breadcrumb */
	.breadcrumb {
		margin-bottom: 30px;
		font-size: 14px;
		color: #888;
	}

	.breadcrumb-item {
		cursor: pointer;
		transition: color 0.3s;
	}

	.breadcrumb-item:hover {
		color: #fff;
	}

	.breadcrumb-item.active {
		color: #fff;
		cursor: default;
	}

	.separator {
		margin: 0 10px;
		color: #666;
	}

	/* Course Grid */
	.course-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 20px;
	}

	.course-card {
		background-color: transparent;
		transition: transform 0.3s;
		cursor: pointer;
	}

	.course-card:hover {
		transform: translateY(-5px);
	}

	.course-cover {
		height: 160px;
		background-color: #333;
		border-radius: 8px;
		margin-bottom: 12px;
		position: relative;
		overflow: hidden;
		background-size: cover;
		background-position: center;
	}

	.course-cover img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.course-info h4 {
		margin: 0 0 8px 0;
		font-size: 16px;
		font-weight: normal;
		line-height: 1.4;
		height: 44px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.course-info p {
		margin: 0;
		font-size: 12px;
		color: #666;
	}

	/* Badges */
	.badge {
		position: absolute;
		top: 0;
		right: 0;
		padding: 2px 8px;
		font-size: 12px;
		font-weight: bold;
		border-radius: 0px 6px 0px 6px;
		color: #522606;
	}

	.badge.free {
		background: linear-gradient(90deg, #FFC972 0%, #FFA73B 100%);
	}

	.badge.vip {
		background: linear-gradient(90deg, #FFC972 0%, #FFA73B 100%);
	}

	.badge.paid {
		background: linear-gradient(90deg, #FFC972 0%, #FFA73B 100%);
	}
	
	/* Removed .empty-state style as it is now handled by the component */

	@media (max-width: 1024px) {
		.course-grid {
			grid-template-columns: repeat(3, 1fr);
		}
	}

	@media (max-width: 768px) {
		.course-grid {
			grid-template-columns: repeat(2, 1fr);
		}
	}
</style>